import React, { useState } from "react";
import axios from "axios";

const API_TOKEN = process.env.REACT_APP_API_TOKEN;
const API = process.env.REACT_APP_API_FOLDER;

function FieldNoteAccess() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  async function submit(event) {
    event.preventDefault();
    if (sending) return;
    setSending(true);
    setError("");
    try {
      await axios.post(
        `${API}fieldnote_request_access/`,
        { email: email.trim() },
        { headers: { "X-API-TOKEN": API_TOKEN, "Content-Type": "application/json" } }
      );
      setDone(true);
    } catch (_) {
      setError("We could not process that request just now. Please try again in a moment.");
    } finally {
      setSending(false);
    }
  }

  return (
    <section className="fieldnote-workspace-page pt-110 section-bottom-pad">
      <div className="container">
        <div className="fieldnote-public-form fieldnote-access-form">
          <span className="fieldnote-kicker">CAMP FIELD NOTES</span>
          <h1>Request a new writer link</h1>
          {done ? (
            <>
              <p>
                If that email address has an editable Field Note, a new private writer link has been sent.
              </p>
              <p className="text-muted">
                Check your inbox and spam folder. For security, we do not confirm whether an email address has a Field Note attached to it.
              </p>
            </>
          ) : (
            <>
              <p className="fieldnote-form-intro">
                Lost the private link for your Field Note? Enter the email address you used for your proposal and we will send a new one if the article is still editable.
              </p>
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={submit}>
                <label>
                  Email
                  <input
                    className="form-control"
                    type="email"
                    required
                    maxLength="200"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
                <button className="btn btn-primary mt-3" type="submit" disabled={sending}>
                  {sending ? "Sending…" : "Send a new writer link"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default FieldNoteAccess;
